<template>
  <f7-actions
    v-model:opened="opened"
    grid
    class="parts-details-secondary-actions"
  >
    <f7-actions-group v-if="workPartDetails">
      <f7-actions-label>
        {{ $t('common.whatDoYouWantToDo') }}
      </f7-actions-label>

      <f7-actions-button
        v-if="isUserResponsible"
        @click="isChangeMachinePopupOpened = true"
      >
        <template #media>
          <UCSvgIcon
            name="fa6-solid-pen"
            width="46px"
            height="46px"
          />
        </template>
        <span>Cambiar máquina</span>
      </f7-actions-button>

      <f7-actions-button @click="openPartHistoryPopup">
        <template #media>
          <img
            src="@/static/img/ic_timer.svg"
            width="48px"
          >
        </template>
        <span>Histórico de partes</span>
      </f7-actions-button>

      <f7-actions-button
        v-if="showChangeDate"
        @click="isChangeDatePopupOpened = true;"
      >
        <template #media>
          <UCSvgIcon
            name="fa6-solid-clock"
            width="46px"
            height="46px"
          />
        </template>
        <span>Cambiar fecha</span>
      </f7-actions-button>
    </f7-actions-group>

    <!-- Popup: Change Machine -->
    <PCChangeMachinePopup
      v-model:opened="isChangeMachinePopupOpened"
      :work-part-id="workPartDetails?.Id_ParteProduccion"
      @machine-updated="handleMachineUpdate"
    />

    <!-- Popup: Part History (Machine History) -->
    <PCPartHistoryPopup ref="partHistoryPopup" />

    <PCPartsDetailsChangeDatePopup
      v-model:opened="isChangeDatePopupOpened"
      :work-part-id="workPartDetails?.Id_ParteProduccion"
      @success="onPartDartChange"
    />
  </f7-actions>
</template>

<script setup>
// @ts-check

import { computed, ref, shallowRef } from 'vue';
import { useRepairParts } from '@/composables/useRepairParts';

import UCSvgIcon from '@/components/common/UCSvgIcon.vue';
import PCChangeMachinePopup from '../PCChangeMachinePopup.vue';
import PCPartHistoryPopup from '../PCPartHistoryPopup.vue';
import PCPartsDetailsChangeDatePopup from './PCPartsDetailsChangeDatePopup.vue';

/** @import { Ref, ShallowRef } from 'vue' */

const opened = defineModel('opened', { type: Boolean, default: false });

/** @type {Ref<boolean>} */
const isChangeMachinePopupOpened = ref(false);

/** @type {ShallowRef<InstanceType<typeof PCPartHistoryPopup> | null>} */
const partHistoryPopup = shallowRef(null);

/** @type {Ref<boolean>} */
const isChangeDatePopupOpened = ref(false);

const {
  workPartDetails,
  fetchWorkPartDetails,
  isUserResponsibleWorkPart,
} = useRepairParts();

const isUserResponsible = computed(() => !!workPartDetails.value
  && isUserResponsibleWorkPart(workPartDetails.value.Id_TrabajadorPropietario));

const showChangeDate = computed(() => !!workPartDetails.value
  && !workPartDetails.value.TrabajosEnDomicilio
  && isUserResponsible.value);

function handleMachineUpdate() {
  if (!workPartDetails.value) {
    return;
  }

  fetchWorkPartDetails(workPartDetails.value.Id_ParteProduccion);
}

function openPartHistoryPopup() {
  if (!workPartDetails.value) {
    return;
  }

  partHistoryPopup.value?.openPopup(workPartDetails.value);
}

function onPartDartChange() {
  if (!workPartDetails.value) {
    return;
  }

  fetchWorkPartDetails(workPartDetails.value.Id_ParteProduccion);
}
</script>

<style scoped lang="scss">
.parts-details-secondary-actions {
  :deep(.actions-group) {
    .actions-button-media {
      justify-content: center;
    }

    .actions-button {
      flex: 0 0 33.33%;
    }
  }
}
</style>
